/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

import {
  CREATE_NEW_USER_SUCCESS,
  CREATE_NEW_USER_FAILURE,
  CREATE_NEW_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  FETCH_USER_REQUEST,
  UPDATE_ROLE_FEATURES_SUCCESS,
  UPDATE_ROLE_FEATURES_FAILURE,
  UPDATE_ROLE_FEATURES_REQUEST,
  LOGOUT_USER,
  ADD_ROLE_TO_USER_SUCCESS,
  ADD_ROLE_TO_USER_FAILURE,
  ADD_ROLE_TO_USER_REQUEST,
  UPDATE_USER,
} from '../constants';

import fetch from '../core/fetch';

export function createUser(imie, nazwisko, email, haslo, prefix) {
  return function (dispatch) {
    dispatch({ type: CREATE_NEW_USER_REQUEST });
    return fetch(process.env.API_URL + '/users/' + prefix + '/register?' + 'imie=' + imie + '&nazwisko=' + nazwisko + '&email=' + email + '&haslo=' + haslo,{
      method: 'POST',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json().then(r => {
        console.debug(r)
      })
    })
    .then((response) => {
      dispatch({ type: CREATE_NEW_USER_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {

      dispatch({ type: CREATE_NEW_USER_FAILURE });
    });
  };
}

//http GET http://localhost:8000/api/v1.0/users/gmina_cieszanow/user/ username==gregorowicz.k@gmail.com

export function fetchUser(username, passwd, prefix) {
  return function (dispatch) {
    dispatch({ type: FETCH_USER_REQUEST });
    const hash = new Buffer(`${username}:${passwd}`).toString('base64')
    return fetch(process.env.API_URL + '/users/' + prefix + '/user/login', {
      method: 'GET',
      headers: {
        'Authorization': `Basic ${hash}`,
      },
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: FETCH_USER_FAILURE });
        throw response.json();
      }
    })
    .then((response) => {
      dispatch({ type: FETCH_USER_SUCCESS, payload: response.user });
      return response;
    })
    .catch(error => {
      return error;
    });
  };
}

export function logOut() {
  return function (dispatch) {
    dispatch({ type: LOGOUT_USER });
  };
};

export function updateRoleFeatures(prefix, changes, role) {
  return dispatch => {
    const data = JSON.stringify({ changes, role });
    dispatch({ type: UPDATE_ROLE_FEATURES_REQUEST });
    return fetch(process.env.API_URL + '/' + prefix + '/role/features', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: UPDATE_ROLE_FEATURES_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: UPDATE_ROLE_FEATURES_FAILURE });
      throw error;
    });
  };
}

export function addRoleToUser(prefix, username, role) {
  return dispatch => {
    const data = JSON.stringify({ username, role });
    dispatch({ type: ADD_ROLE_TO_USER_REQUEST });
    return fetch(process.env.API_URL + '/users/' + prefix + '/addrole', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: ADD_ROLE_TO_USER_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: ADD_ROLE_TO_USER_FAILURE });
      throw error;
    });
  };
}

export function update_user(user) {
  return dispatch => {
    dispatch({ type: UPDATE_USER, payload: user });
  };
};



// WEBPACK FOOTER //
// src/actions/user.js